import { AuthContext } from 'context/AuthContext'
import { useDispatch, useSelector } from 'react-redux'
import { IRedux } from 'store/ducks'
import Creators from 'store/ducks/authenticate'
import { useContextSelector } from 'use-context-selector'
const useAuth = () => {
  const dispatch = useDispatch()

  // ### TOKEN
  const token = useSelector((state: IRedux) => state.auth.token)
  const setToken = (newToken: string) => dispatch(Creators.token(newToken))

  // ### TOKEN
  // ### USER
  const user = useSelector((state: IRedux) => state.auth.user)
  const setUser = (newUser: UsuarioToken) => dispatch(Creators.user(newUser))
  // ### USER

  // ### USER FORNECEDOR
  const usuarioFornecedor = useSelector(
    (state: IRedux) => state.auth.fornecedor
  )
  const setUsuarioFornecedor = (newUser: UsuarioFornecedorToken) =>
    dispatch(Creators.fornecedor(newUser))

  const setTipoUsuario = (tipo: string) => dispatch(Creators.tipo(tipo))

  const TipoUsuario = useSelector((state: IRedux) => state.auth.tipo)
  // ### USER FORNECEDOR

  // ### USER CSN
  const usuarioCsn = useSelector((state: IRedux) => state.auth.csn)
  const setUsuarioCsn = (newUser: UsuarioFornecedorToken) =>
    dispatch(Creators.csn(newUser))

  // ### USER CSN

  // ### IS LOGED
  const isLogged = useSelector((state: IRedux) => state.auth.logged)
  const setIsLogged = (newValue: boolean) => dispatch(Creators.logged(newValue))

  // ### IS LOGED

  // ### ALL DATA
  const allDatadescripted = useSelector((state: IRedux) => state.auth.data)
  const setAllData = (data: any) => dispatch(Creators.data(data))
  // ### ALL DATA
  const handleLogin = useContextSelector(
    AuthContext,
    (state) => state?.handleLogin
  )

  const logout = useContextSelector(AuthContext, (state) => state?.logout)

  return {
    TipoUsuario,
    allDatadescripted,
    handleLogin,
    isLogged,
    logout,
    setAllData,
    setIsLogged,
    setTipoUsuario,
    setToken,
    setUser,
    setUsuarioCsn,
    setUsuarioFornecedor,
    token,
    user,
    usuarioCsn,
    usuarioFornecedor
  }
}

export default useAuth

export interface UsuarioToken {
  IdUsuario: number
  PerfilUsuarioId: number
  NmUsuario: string
  TxEmail: string
  NuContato: string
  CdDocto: string
  NuRamal: string
  ExternalId?: any
}

export interface UsuarioFornecedorToken {
  NmMatricula?: string
  FornecedorId?: number
  CdDocto?: string
  FlSituacao?: string
  DtSituacao?: Date
  DtValidade?: Date
  DtRevalidacaoSenha?: Date
  FlPrimeiroAcesso?: boolean
  UsuarioId?: number
  ExternalUsuarioId?: string
  IdUsuarioFornecedor?: number
}

export interface AllData {
  id: string
  Fornecedor: string
  Usuario: string
  Perfil: string
  exp: number
  iss: string
  aud: string
}
